import { render, staticRenderFns } from "./campos-custom.vue?vue&type=template&id=3fed9e1e&"
import script from "./campos-custom.vue?vue&type=script&lang=js&"
export * from "./campos-custom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports